import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UploadEditedImageComponent } from 'src/app/community/upload-edited-image/upload-edited-image.component';
import { EditedImageResult } from 'src/app/community/upload-edited-image/upload-edited-image.types';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-site-links',
  templateUrl: './site-links.component.html',
  styleUrl: './site-links.component.scss',
})
export class SiteLinksComponent implements AfterViewInit, OnInit {
  @ViewChild('mainContainer') mainContainer: ElementRef;

  @Output()
  filterProductByFavorite = new EventEmitter();

  carouselWithNavOptions2: any = {
    spaceBetween: 1,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
  };
  isUserLogin: any = 0;
  filterByPopular() {
    this.filterProductByFavorite.emit('');
  }

  constructor(
    private router: Router,
    private local: LocalServiceService,
    public sharedService: SharedService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService
  ) { }


  private referralCode = '';
  ngOnInit(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (!this.sharedService.isBrowser()) {
        return;
      }
      this.referralCode = this.local.getUser()?.referralCode;
      if (user?.id) {
        this.isUserLogin = 1;
        this.links = [...this.links]
      } else {
        this.isUserLogin = 0;
      }
    });
  }
  ngAfterViewInit(): void {
    // if(window.innerWidth <= 767){
    //   const scrollAmount = (document.documentElement.scrollWidth * 37.5) / 100;
    //   this.mainContainer?.nativeElement?.scroll(scrollAmount, 0)
    // }
  }


  ///////////////////////////////////////////////////////////////////////////////////////////
  public subregionImageUploadId = 'subregion-upload-image'
  public subregionImageUploadIdCamera = 'subregion-upload-image-camera'
  public selectedRegionImageToUpload: File | null = null
  public selectedRegionImageToUploadBuffer = null

  public subregionImageUploadChanged(event) {
    const { target } = event;
    const file = target.files[0];

    this.selectedRegionImageToUpload = file

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.selectedRegionImageToUploadBuffer = fileReader.result;
    }
    fileReader.readAsDataURL(this.selectedRegionImageToUpload)

  }
  private getActiveSubregionId() {
    let subRegionId = this.local.getUser()?.region;


    return subRegionId
  }
  public subregionImageUploadCurrentCaption = '';
  public submitSubregionFileUpload() {
    if (!this.selectedRegionImageToUpload) {
      this.toastr.info("Please select an image first")
      return;
    }
    const uploadData = new FormData();
    uploadData.append('subregionId', this.getActiveSubregionId())
    uploadData.append('image', this.selectedRegionImageToUpload);
    uploadData.append('caption', this.subregionImageUploadCurrentCaption);

    this.auth.uploadSubregionImage(uploadData)
      .subscribe({
        next: () => {
          this.toastr.success("Uploaded!")
          this.selectedRegionImageToUpload = null;
          this.selectedRegionImageToUploadBuffer = null;
          this.subregionImageUploadCurrentCaption = '';
          this.modalService.dismissAll();
          this._getSubRegionImages()
        },

        error: err => {
          this.toastr.error("Error something went wrong!");
          console.error(err)
        }
      })
  }



  public currentCropInformationToBeSaved = null;



  public openUploadSubregionImageModal() {
    const modalRef = this.modalService.open(UploadEditedImageComponent, { size: 'sm', centered: true });
    let topText = '';
    const user = this.local.getUser();

    if (user) {
      topText = this.commonService.getSubregionName(user.region);
    }

    modalRef.componentInstance.topText = topText;
    modalRef.result.then(
      (res: EditedImageResult) => {
        this.currentCropInformationToBeSaved = res.cropInformation;
        this.selectedRegionImageToUpload = res.imageData as File;
        this.subregionImageUploadCurrentCaption = res.caption;
        this.submitSubregionFileUpload();
      }
    )

  }
  public subregionUploadedImage = []
  public showImagePopup(url, text = '') {

    this.modalService.dismissAll();
    const instance = this.modalService.open(ImageModalComponent, {
      size: "sm",
      windowClass: "image-modal",
    });
    instance.componentInstance.imageSrc = environment.ImageUrl + url;
    instance.componentInstance.descr = text;

  }

  private _getSubRegionImages() {
    this.auth.getSubRegionUploadedImages(this.getActiveSubregionId())
      .subscribe(
        {
          next: data => {
            this.subregionUploadedImage = data.body;

          },
          error: err => {
            console.error(err);
          }
        }
      )
  }

  public toggleUploadRxn(uploadedImage, type) {
    this.auth.toggleUploadReaction(uploadedImage.id, type).subscribe(
      {
        next: () => {
          this._getSubRegionImages();
        },
        error: err => {
          console.error(err);
          this.toastr.error("Error something went wrong while reacting")
        }
      }
    )

  }
  ////////////////////////////////////////////////////////////////////////////////////////

  public clickLogin() {
    this.modalService.dismissAll();
    this.commonService.clickButton('loginBtn');
  }
  public loginWhy = '';
  @ViewChild('whyLogin') public whyLogin: TemplateRef<any>;
  public openLink(link, name) {
    const isUserLoggedIn = this.local.getUser();
    if (!isUserLoggedIn && ['Nearby', 'Favourites', 'Report Bug', 'Share Moment'].includes(name)) {
      this.loginWhy = name?.toLowerCase();

      this.modalService.open(this.whyLogin, { size: 'sm', centered: true, modalDialogClass: 'w-50', windowClass: 'd-flex justify-content-center' })
      return;
    }
    if (name == 'Share Moment') {
      this.openUploadSubregionImageModal();
      return;
    }
    if (name == 'Report Bug') {
      this.local.alertReport()
        .then((result) => {
          if (result.isConfirmed && result.value) {
            const report = result.value;

            const data = new FormData();
            data.append('message', report.reportDetails);
            data.append('type', report.reportType)
            data.append('category', 'member');
            data.append('image', report.file);
            this.auth
              .submitReportMessage(data)
              .subscribe(
                () => {
                  this.toastr.success('Reported successfully');
                },
                (e) => {
                  this.toastr.error(e.error.message);
                }
              );
          }
        });;
      return
    }

    if (name == 'Favourites') {
      link = link + this.local?.getUser()?.referralCode
    }
    this.router.navigateByUrl(link);
  }

  public links: any = [
    {
      name: 'Nearby',
      image: 'search_2.png',
      link: '/community/me/nearby',
    },
    {
      name: 'Giveaway',
      image: 'gift_2.png',
      link: '/giveaway',
      // glow: true,
    },
    {
      name: 'Share Moment',
      image: 'near-me-upload.webp',
      link: '-'
    },
    {
      name: 'Report Bug',
      image: 'bug.webp',
      link: null,
    },
    {
      name: 'Join us',
      image: 'join.png',
      link: '/biz/join',
    },
    {
      name: 'Favourites',
      image: 'love.png',
      link: '/community/profile/'
    },
    {
      name: 'News',
      image: 'news.png',
      link: '/news',
    },
    {
      name: 'FAQ',
      image: 'faq.png',
      link: '/faq',
    },
  ];
}
